// Vendor libs
import React from 'react';

// Components
import {CheckAuthSession} from '@dishtech-react/core';
import Layout from './Layout';
import Table from './Table';

// Styles
import './Whitelist.css';

export default () => (
  <Layout>
    <CheckAuthSession />
    <Table />
  </Layout>
);
